import BasicModal from '../common/BasicModal';
import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, TextField } from '@mui/material';
import Upload from '../common/Upload';
import { MediaFile } from '../../interfaces/file';

type IAddPostModal = {
	open: boolean;
	onClose: () => void;
	handleSaveNotSocial: (e: any) => void;
	medias?: MediaFile[];
	files: (File | string)[];
	setFiles: React.Dispatch<React.SetStateAction<(File | string)[]>>;
};

const WebsiteAdModal: FC<IAddPostModal> = ({ open, onClose, handleSaveNotSocial, files, setFiles }) => {
	const { t } = useTranslation();
	const { selectedPlatform, selectedCampaignId, contentStatus, selectedPages, selectedPlatformId, selectedContentType, selectedMediaTypeId } = useContext(CampaignContext);
	const [link, setLink] = useState<string>('');
	const [text, setText] = useState<string>('');
	const [pictureType, setPictureType] = useState<string>('');
	const params = {
		description: text,
		images: files,
		picture_type: pictureType,
		id: null,
		campaign_id: selectedCampaignId,
		content_status: contentStatus,
		media_id: selectedPlatformId,
		media_type_id: selectedPlatform === 'sms' ? 'sms' : selectedMediaTypeId,
		text: text,
		link: link,
		price: selectedPages.length > 0 && selectedPages[0].price,
	};
	useEffect(() => {
		setFiles([]);
		setLink('');
		setText('');
		setPictureType('');
	}, [selectedPlatform, selectedMediaTypeId, selectedContentType]);
	return (
		<BasicModal
			className={`h-auto w-3/12`}
			open={open}
			onClose={onClose}
			titleKey={`${selectedMediaTypeId === 'push_notification' ? 'push_notification' : selectedMediaTypeId === 'reportage' ? 'reportage' : 'banner'}`}
			titleValues={{
				contentType: t(selectedContentType as string),
			}}
		>
			{selectedMediaTypeId === 'push_notification' ? (
				<>
					<FormControl fullWidth>
						<div className="flex w-full flex-wrap justify-around gap-x-4 pt-8">
							<TextField placeholder={t('link')} onChange={e => setLink(e.target.value)} fullWidth className="my-2" />
							<Upload type={'media'} IsSerialStory={true} className="w-full" files={files} setFiles={setFiles} text={t('upload_image_video_image')} multiple />
							<TextField placeholder={t('text_message')} onChange={e => setText(e.target.value)} className="my-2" multiline fullWidth rows={4} maxRows={4} />
						</div>
					</FormControl>
				</>
			) : (
				<>
					<FormControl fullWidth>
						<div className="flex w-full flex-wrap justify-around gap-x-4 pt-8">
							<Upload type={'media'} IsSerialStory={true} className="w-full" files={files} setFiles={setFiles} text={t('upload_image_video_image')} multiple />
							<TextField placeholder={t('reportage_user_text')} onChange={e => setText(e.target.value)} className="my-2" multiline fullWidth rows={3} maxRows={4} />
							{/* <Upload /> */}
							<FormGroup className="my-3 flex items-center justify-start">
								<FormControlLabel control={<Checkbox onChange={() => setPictureType('full_screen')} name={'full_screen'} defaultChecked />} label={t('full_screen')} />
								<FormControlLabel control={<Checkbox onChange={() => setPictureType('banner')} />} name={'banner'} label={t('banner')} />
							</FormGroup>
						</div>
					</FormControl>
				</>
			)}
			<Button onClick={() => handleSaveNotSocial(params)} className="mt-5" fullWidth>
				{t('register')}
			</Button>
		</BasicModal>
	);
};

export default WebsiteAdModal;
